import { getIsSdkError } from '../../goloom-sdk';
import { DeviceErrorCode } from '../types';

export function getDeviceErrorCode(error: unknown): DeviceErrorCode {
    return getIsSdkError(error) ? error.code : 'UNKNOWN';
}
